import { IconSet } from '@postscript/components';
import { useMemo } from 'react';

import { PERMISSIONS } from 'components/account/AccountView/users/constants';
import {
  ENTITLEMENTS_ACQUISITION,
  SHOW_CASHBACK_PAGES,
} from 'components/admin/utils/feature-flags';
import { NavMenuItem, SubMenuItem } from 'components/navigation/NavMenu';
import { useHasActivePopups } from 'components/Popup/hooks/useHasActivePopups';
import { ROUTE_POPUPS_BLOCK, SUBROUTE_LIST } from 'components/popups/constants';
import { usePSLabs } from 'controllers/contexts/labsFeatures';
import { EntitlementKeys } from 'providers/entitlements/types';

export const useAcquisitionsMenuItems = () => {
  const hasActiveLegacyPopups = useHasActivePopups();
  const { hasLabsFlag } = usePSLabs();
  const hasEntitlementsFlag = hasLabsFlag(ENTITLEMENTS_ACQUISITION);

  return useMemo(
    (): NavMenuItem[] => [
      {
        id: 'acquisition',
        label: 'Acquisition',
        icon: IconSet.UsersPlus,
        isLoading: false,
        ariaLabelledBy: 'nav-list-growth-title',
        restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
        subMenu: [
          {
            id: 'acquisition-popups-block-popups',
            label: 'Popups',
            link: `${ROUTE_POPUPS_BLOCK}${SUBROUTE_LIST}`,
            entitlementKey: hasEntitlementsFlag
              ? 'acquisition::popups::view'
              : undefined,
          },
          ...(hasActiveLegacyPopups
            ? ([
                {
                  id: 'acquisition-popups',
                  label: 'Legacy Popups',
                  link: '/popups',
                  entitlementKey: hasEntitlementsFlag
                    ? 'acquisition::popups::view'
                    : undefined,
                },
              ] as SubMenuItem[])
            : []),
          {
            id: 'acquisition-keywords',
            label: 'Keywords',
            link: '/keywords',
            entitlementKey: hasEntitlementsFlag
              ? 'acquisition::keywords::view'
              : undefined,
          },
          {
            id: 'acquisition-list-growth',
            label: 'List Growth Tools',
            link: '/grow',
            entitlementKey: hasEntitlementsFlag
              ? 'acquisition::list_growth::view'
              : undefined,
          },
          {
            id: 'acquisition-checkout',
            label: 'Checkout Collection',
            link: '/checkout',
            entitlementKey: hasEntitlementsFlag
              ? 'acquisition::checkout::view'
              : undefined,
          },

          {
            id: 'acquisition-cashback-pages',
            label: 'CashBack',
            link: '/cashback',
            labsFeatureFlag: SHOW_CASHBACK_PAGES,
            entitlementKey: hasEntitlementsFlag
              ? EntitlementKeys.FONDUE_SERVICE_VIEW
              : undefined,
          },
        ],
      },
    ],
    [hasActiveLegacyPopups, hasEntitlementsFlag],
  );
};
